import { render, staticRenderFns } from "./SystemRiskScenario.vue?vue&type=template&id=901e6b5c&scoped=true&"
import script from "./SystemRiskScenario.vue?vue&type=script&lang=js&"
export * from "./SystemRiskScenario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901e6b5c",
  null
  
)

export default component.exports